import { ui as initialState } from 'flux/initialState'
import { ui as actions } from 'flux/actions'

export default function (state = initialState, action) {
  const { types } = actions

  switch (action.type) {
    case types.TOGGLE_DRAWER: {
      const { drawer } = state
      const { active } = action.payload
      return { ...state, drawer: { ...drawer, active } }
    }
    case types.TOGGLE_MODAL: {
      const { modal } = state
      const { active } = action.payload
      return { ...state, modal: { ...modal, active } }
    }
    case types.TOGGLE_SNACKBAR: {
      const { snackbar } = state
      const { active, message, buttonText } = action.payload
      return {
        ...state,
        snackbar: {
          ...snackbar, active, message, buttonText,
        },
      }
    }
    case types.TOGGLE_FULLSCREEN_BUTTON: {
      const { fullscreenButton } = state
      const { visible } = action.payload
      return {
        ...state,
        fullscreenButton: {
          ...fullscreenButton,
          visible,
        },
      }
    }
    case types.TOGGLE_BANNER: {
      const { banners } = state
      const { id, active } = action.payload
      return {
        ...state,
        banners: {
          ...banners,
          [id]: { active },
        },
      }
    }
    case types.SET_DEVICE_WIDTH: {
      const { deviceWidth } = action.payload
      return { ...state, deviceWidth }
    }
    case types.SET_DEVICE_HEIGHT: {
      const { deviceHeight } = action.payload
      return { ...state, deviceHeight }
    }
    case types.SET_DEVICE_SIZE: {
      const { deviceSize } = action.payload
      return { ...state, deviceSize }
    }
    case types.SET_IS_MOBILE_MENU_OPEN: {
      const { isMobileMenuOpen } = action.payload
      return { ...state, isMobileMenuOpen }
    }
    case types.SET_IS_VERTICAL_SCROLL_ENABLED: {
      const { isVerticalScrollEnabled } = action.payload
      return { ...state, isVerticalScrollEnabled }
    }
    default:
      return state
  }
}
